<template>
    <HeaderComponent />
    <ScrollableView class="view-container" contentClass="items-view"> </ScrollableView>
</template>

<script setup lang="ts">
    import { onBeforeUnmount, onMounted, ref } from "vue";

    import ScrollableView from "@/components/layout/ScrollableView.vue";
    import HeaderComponent from "@/operator/components/layout/HeaderComponent.vue";

    // state
    const isLoading = ref(false);

    // define html refs

    // functions

    // register events
    onMounted(async () => {});

    onBeforeUnmount(() => {});
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_variables.scss";
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .app > .items {
        > .scrollable {
            label {
                font-size: 14px;
                font-weight: 500;
            }

            .temp-not-available-item-btn[disabled] {
                cursor: default;
            }

            .stockeditor {
                display: flex;
                flex-shrink: 0;
                position: relative;
                justify-content: flex-end;

                > .editor {
                    white-space: nowrap;
                    display: flex;
                    align-items: center;

                    > .form-control-check {
                        display: inline-block;
                        margin-right: 12px;
                    }

                    > .bootstrap-touchspin {
                        display: inline-flex;
                        width: 120px;
                        margin-right: 12px;

                        > .form-control {
                            text-align: right;
                            padding-right: 38px;
                        }
                    }
                }

                > .disablewarning {
                    position: relative;
                    left: 26px;
                    top: 8px;
                    z-index: 1;

                    > i {
                        color: colors.$orange;
                        font-size: 16px;
                    }
                }

                .btn[disabled] {
                    cursor: default !important;
                }
            }
        }
    }

    .app > .items {
        > .scrollable {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 52px;

            > .tabulator {
                font-size: 1.1rem;
            }
        }
    }
</style>
